import { MimeTypes } from "./types/MimeTypes";
import { FIELDS } from "./types/GDriveFile";

const qMimeTypes = Object.values(MimeTypes).map(mime => `mimeType='${mime}'`).join(" or ");
const fields = `files(${FIELDS.join(", ")})`;

export const createOptions = (parent = "root") => ({
  corpora: "user",
  spaces: "drive",
  q: `'${parent}' in parents and trashed = false and (${qMimeTypes})`,
  fields,
  orderBy: "folder, name",
});
